import React from 'react'
import {CheckCircleFilled} from "@ant-design/icons";

interface Props {}

const FunctionCard = ({icon, title, desc}) => {

  return (
    <div className="bg-white/60 backdrop-blur-sm rounded-xl border border-gray-100 hover:shadow-md hover:bg-white/80 transition-all duration-200">
      <div className="p-5">
        <div className={"flex flex-row gap-3 items-center"}>
          <div className="w-12 h-12 rounded-xl bg-gray-50 flex items-center justify-center">
            {icon}
          </div>
          <div>
            <p className="text-sm font-medium text-gray-800">{title}</p>
            <p className={"text-xs text-gray-500 mt-0.5"}>{desc}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FunctionCard;
